import React from "react";
import { motion } from "framer-motion";
import { fadeUp, stagger, VIEWPORT_LG, VIEWPORT_SM } from "./motion";

const BG_IMG =
  "https://images.unsplash.com/photo-1526289034009-0240ddb68ce3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGRhcmslMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzgzMzA3ODMwfDA&ixlib=rb-4.1.0&q=85";

const PILLARS = [
  { k: "Independent", v: "We determine the means and methods — a true independent partner, never a directed vendor." },
  { k: "Discreet", v: "Confidentiality is absolute. Relationships and information are protected without exception." },
  { k: "Accountable", v: "Defined service levels, structured reporting and quarterly reviews keep us measurable." },
];

const STATS = [
  { n: "4 Markets", l: "FX · Indices · Futures · Digital Assets" },
  { n: "Monthly", l: "Performance & intelligence reporting" },
  { n: "Quarterly", l: "Strategy & partnership reviews" },
  { n: "< 4 Hours", l: "Response on material dislocations" },
];

export const Approach = () => {
  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="relative bg-[#050505] py-24 md:py-32 overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-[0.06]"
        style={{ backgroundImage: `url(${BG_IMG})` }}
        aria-hidden="true"
      />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={VIEWPORT_LG}
          className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start"
        >
          <div className="lg:col-span-5">
            <motion.p
              variants={fadeUp}
              className="font-mono-accent text-[11px] md:text-sm tracking-[0.28em] uppercase text-[#737373] mb-6"
            >
              The Wolf Land Standard
            </motion.p>
            <motion.h2
              variants={fadeUp}
              data-testid="approach-heading"
              className="font-heading text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight text-white leading-tight"
            >
              Institutional service, held to an institutional standard.
            </motion.h2>
          </div>

          <div className="lg:col-span-7 space-y-10">
            {PILLARS.map((p) => (
              <motion.div
                key={p.k}
                variants={fadeUp}
                data-testid={`approach-pillar-${p.k.toLowerCase()}`}
                className="border-l border-white/15 pl-6"
              >
                <h3 className="font-heading text-xl md:text-2xl font-medium text-white mb-2">
                  {p.k}
                </h3>
                <p className="text-sm md:text-base leading-relaxed text-[#A3A3A3] max-w-xl">
                  {p.v}
                </p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={VIEWPORT_SM}
          className="mt-20 md:mt-28 grid grid-cols-2 lg:grid-cols-4 border-t border-white/10"
        >
          {STATS.map((s) => (
            <motion.div
              key={s.n}
              variants={fadeUp}
              data-testid={`approach-stat-${s.n.replace(/\W+/g, "-").toLowerCase()}`}
              className="border-b lg:border-b-0 border-r border-white/10 last:border-r-0 py-8 md:py-10 pr-4"
            >
              <div className="font-heading text-2xl md:text-4xl font-medium text-white tracking-tight">
                {s.n}
              </div>
              <div className="mt-2 font-mono-accent text-[10px] md:text-xs tracking-[0.14em] uppercase text-[#737373] leading-relaxed">
                {s.l}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
